import { render, staticRenderFns } from "./OrganList.vue?vue&type=template&id=9499c1d8&scoped=true&"
import script from "./OrganList.vue?vue&type=script&lang=js&"
export * from "./OrganList.vue?vue&type=script&lang=js&"
import style0 from "./OrganList.vue?vue&type=style&index=0&id=9499c1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9499c1d8",
  null
  
)

export default component.exports